var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 15.9102C23.67 15.9102 22.66 16.4602 22.03 17.3002C21.4 16.4602 20.39 15.9102 19.26 15.9102C17.35 15.9102 15.8 17.4702 15.8 19.3902C15.8 20.1302 15.92 20.8202 16.12 21.4502C17.1 24.5602 20.14 26.4302 21.64 26.9402C21.85 27.0102 22.2 27.0102 22.41 26.9402C23.91 26.4302 26.95 24.5702 27.93 21.4502C28.14 20.8102 28.25 20.1302 28.25 19.3902C28.26 17.4702 26.71 15.9102 24.8 15.9102Z",
    fill: "#FF671E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 14.3396C26.75 14.5696 26.52 14.7196 26.3 14.6596C24.95 14.3096 23.47 14.5996 22.35 15.3996C22.13 15.5596 21.83 15.5596 21.62 15.3996C20.83 14.8196 19.87 14.4996 18.86 14.4996C16.28 14.4996 14.18 16.6096 14.18 19.2096C14.18 22.0296 15.53 24.1396 16.89 25.5496C16.96 25.6196 16.9 25.7396 16.81 25.6996C14.08 24.7696 8 20.9096 8 14.3396C8 11.4396 10.33 9.09961 13.21 9.09961C14.92 9.09961 16.43 9.91961 17.38 11.1896C18.34 9.91961 19.85 9.09961 21.55 9.09961C24.42 9.09961 26.75 11.4396 26.75 14.3396Z",
    fill: "#FF671E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.2be46d89634135b21a45aedef9212437.svg";
export { ForwardRef as ReactComponent };